import PropTypes from 'prop-types';
import { Svg } from './Svg.js';
import { EssentialsListDescription } from './EssentialsListDescription.js';
import { EssentialsListDonateButton } from './EssentialsListDonateButton.js';

/**
 * Like a {@link ProjectCard}, but for EssentialsLists!
 *
 * Show this when this is a search that *should* include EssentialsLists, for some value of "should". If the search
 * isn't applicable to EssentialsLists, use EssentialsListPromo instead.
 *
 * Keep this component's API in sync with EssentialsListPromo (another React component with a similar role but subtler
 * style), EssentialsListSearchResultVO (the serialization-class used to populate its props in search), and the relevant
 * Map<String, Object>-populating code in TeacherProfileWebController.
 */
export const EssentialsListCard = ({
    teacherName, teacherNamePossessive, topItemName, topItemImageUrl, topItemPrice, listLength,
    state, stateFullName, city, essentialsListUrl, isMiniVersion, hideTeacherDetails, teacherId,
}) => {
    const location = (hideTeacherDetails || !city) ? stateFullName : `${city}, ${state}`;
    const costToDisplay = topItemPrice > 25 ? 10 : topItemPrice;

    return (
        <a href={essentialsListUrl} className={'essentials-list-card' + (isMiniVersion ? ' mini' : '')}>
            <div className="essentials-description">
                <div className="list-details">
                    <EssentialsListDescription
                        isPromo={false}
                        location={location}
                        teacherName={teacherName}
                        topItemName={topItemName}
                        topItemPrice={costToDisplay}
                    />
                    <EssentialsListDonateButton teacherId={teacherId} topItemPrice={costToDisplay}>
                        <span className="name">Add to cart</span>
                    </EssentialsListDonateButton>
                </div>
            </div>
            <div className="top-supply" style={{ backgroundImage: 'url(' + topItemImageUrl + ')' }}></div>
        </a>
    );
};
EssentialsListCard.propTypes = {
    teacherName: PropTypes.string.isRequired,
    teacherNamePossessive: PropTypes.string.isRequired,
    topItemName: PropTypes.string.isRequired,
    topItemImageUrl: PropTypes.string.isRequired,
    topItemPrice: PropTypes.number.isRequired,
    listLength: PropTypes.number.isRequired,
    essentialsListUrl: PropTypes.string.isRequired,
    city: PropTypes.string,
    state: PropTypes.string,
    stateFullName: PropTypes.string,
    hideTeacherDetails: PropTypes.bool,
    isMiniVersion: PropTypes.bool,
    teacherId: PropTypes.number.isRequired,
};
